import axiosInstance from '../variables/api/axiosInstance';
import { avecLibelleTraduit } from '../i18n/libelles';

const BASE = '/v1/attestations-digitales';

const unwrapList = (res) => {
  const d = res?.data?.data;
  if (Array.isArray(d)) return d;
  if (d?.content && Array.isArray(d.content)) return d.content;
  return [];
};

const unwrapPaginated = (res) => {
  const d = res?.data?.data;
  const list = Array.isArray(d) ? d : (d?.content || []);
  return {
    items: list,
    totalElements: res?.data?.totalElements ?? d?.totalElements ?? list.length,
    currentPage: res?.data?.currentPage ?? d?.number ?? 0,
    pageSize: res?.data?.pageSize ?? d?.size ?? list.length,
    totalPages: res?.data?.totalPages ?? d?.totalPages ?? 1,
  };
};

const unwrap = (res) => res?.data?.data;

// ============== ATTESTATIONS DIGITALES ==============
export async function emettre(payload) {
  return unwrap(await axiosInstance.post(`${BASE}`, payload));
}

export async function getAttestation(trackingId) {
  return unwrap(await axiosInstance.get(`${BASE}/${trackingId}`));
}

export async function getAttestationByNumero(numero) {
  return unwrap(await axiosInstance.get(`${BASE}/numero/${numero}`));
}

export async function listerAttestations(page = 0, size = 20, params = {}) {
  return unwrapPaginated(
    await axiosInstance.get(`${BASE}`, { params: { page, size, ...params } })
  );
}

export async function listerAttestationsParCompagnie(compagnieId, page = 0, size = 20) {
  return unwrapPaginated(
    await axiosInstance.get(`${BASE}/compagnie/${compagnieId}`, { params: { page, size } })
  );
}

export async function revoquer(trackingId, payload) {
  return unwrap(await axiosInstance.put(`${BASE}/${trackingId}/revoquer`, payload));
}

export async function renvoyer(trackingId, payload) {
  return unwrap(await axiosInstance.post(`${BASE}/${trackingId}/renvoyer`, payload));
}

export async function telechargerPdf(token) {
  const res = await axiosInstance.get(`/v1/attestations/telecharger/${token}`, {
    responseType: 'blob',
  });
  return res.data;
}

export async function ouvrirPdf(token) {
  const blob = await telechargerPdf(token);
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

// ============== VERIFICATION PUBLIQUE ==============
export async function verifierParToken(token) {
  return unwrap(await axiosInstance.get(`/v1/verify/${token}`));
}

export async function verifierParQr(payload) {
  return unwrap(await axiosInstance.post('/v1/verify/qr', payload));
}

// ============== STATUTS & CONSTANTES ==============
export const STATUTS_ATTESTATION_DIGITALE = avecLibelleTraduit({
  ACTIVE:    { color: 'success' },
  EXPIREE:   { color: 'default' },
  ANNULEE:   { color: 'error' },
  SUSPENDUE: { color: 'warning' },
}, 'referentiels:statutsAttestationDigitale');

export const STATUTS_INSTANCE = avecLibelleTraduit({
  GENEREE:      { color: 'blue' },
  ENVOYEE:      { color: 'cyan' },
  TELECHARGEE:  { color: 'green' },
  REVOQUEE:     { color: 'red' },
}, 'referentiels:statutsInstanceAttestation');
